import { render, staticRenderFns } from "./MethodologyLink.vue?vue&type=template&id=4571a25e"
import script from "./MethodologyLink.vue?vue&type=script&lang=ts"
export * from "./MethodologyLink.vue?vue&type=script&lang=ts"
import style0 from "./MethodologyLink.vue?vue&type=style&index=0&id=4571a25e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports